import { render, staticRenderFns } from "./GroupCards.vue?vue&type=template&id=4e9b0e9d&scoped=true&"
import script from "./GroupCards.vue?vue&type=script&lang=js&"
export * from "./GroupCards.vue?vue&type=script&lang=js&"
import style0 from "./GroupCards.vue?vue&type=style&index=0&id=4e9b0e9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b0e9d",
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QMenu,QItem,QCard,QIcon,QItemLabel,QList,QSeparator,QDialog,QCardSection,QSpace,QBtn,QCardActions,QInput,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QExpansionItem,QItemSection,QMenu,QItem,QCard,QIcon,QItemLabel,QList,QSeparator,QDialog,QCardSection,QSpace,QBtn,QCardActions,QInput})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple,ClosePopup})
